import React, {Component, Fragment} from "react";
import ReactJson, {OnSelectProps} from "react-json-view";
import LoadingCard from "./LoadingCard";

interface JsonViewerCardProps
{
    title: string;
    jsonObject: object;
    loading?: boolean;
    extraDetail?: string;
    onSelect?: (a: OnSelectProps) => void;
}

interface JsonViewerCardState
{
}

export default class JsonViewerCard extends Component<JsonViewerCardProps,JsonViewerCardState>
{

    constructor(props: JsonViewerCardProps) {
        super(props);

        this.state = {
        }
    }

    public componentDidMount() {
    }
    
    public render() {
        
        const extraDetail = (<Fragment><br/><span className={"text-extra-detail"}>{this.props.extraDetail}</span></Fragment>);
        
        return (
            <Fragment>
                <div className="card">
                    <div className="card__header">
                        <span className={"card__title"}>{this.props.title}
                            {this.props.extraDetail ? extraDetail : null}
                        </span>
                        {this.props.children}
                    </div>
                    <div className={"card__content"}>
                        {this.props.loading === true ? <LoadingCard/> : <ReactJson src={this.props.jsonObject} onSelect={(onSelectProps) =>  {
                            
                            if(this.props.onSelect !== undefined) {
                                this.props.onSelect(onSelectProps);
                            }
                        }} displayDataTypes={true} displayObjectSize={true}  theme="rjv-default"/>}
                    </div>
                </div>
            </Fragment>
        );
    }
}